import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useSubUrl from '../hooks/useSubUrl';

const SubscriptionPrivateRoutes = ({ children }) => {
	const subscription = useSelector((state) => state.userInfo?.userInfo?.data?.subscription);
	const suburl = useSubUrl();

	// subscription.status is the backend's human display string ("Active",
	// "Cancels at end date", ...) not a lowercase enum, so comparing against
	// 'active' here never matched — this guard was effectively a no-op.
	//
	// is_active alone is NOT enough either: a Free subscription is created with
	// status 'active', so is_active is true for Free users too. Guarding on it
	// alone bounced Free users straight back out of checkout/plan-selection —
	// which looked like the page simply reloading. Only users on a PAID active
	// plan should be kept out; Free users need checkout in order to upgrade.
	// A complimentary plan (given free by staff) has nothing paid to protect —
	// it must be able to reach checkout to buy a plan, exactly like Free.
	if (subscription?.is_active && !subscription?.is_free && !subscription?.is_complimentary) {
		return (
			<Navigate
				to={suburl ? `/user/${suburl}/settings/my-subscription` : '/payment-success'}
				replace
			/>
		);
	}

	return children;
};

export default SubscriptionPrivateRoutes;
